//---------------- Start External Library Import --------------------//
import React, { lazy, Suspense } from "react";
import { Router } from "react-router";
import { Route, Switch, Redirect } from "react-router-dom";
import { translate } from "react-i18next";

import { Loader } from "../customComponents/components";
//---------------- End External Library Import --------------------//

//---------------- Start Pages Import --------------------//
const LoginTab = lazy(() => import("../pages/logintab"));
const Dashboard = lazy(() => import("../pages/dashboard"));
// const RblToSbmMigration = lazy(() => import("../pages/rblToSbmMigration"));
//---------------- End Pages Import --------------------//

//---------------- Start Constants Import --------------------//
// Note: Currently named imports are not supported for React.lazy:
// const {ErrorPage} = lazy(() => import("../customComponents/components"));
const ErrorPage = lazy(() => import("../customComponents/errorPage"));
//---------------- End Constants Import --------------------//

//---------------- Start css and SCSS Import --------------------//
import "../sass_scripts/index.scss"; //All pages includes here
//---------------- End css and SCSS Import --------------------//

//---------------- Start Helper Import --------------------//
import history from "helper/history";

const RouteWrapper = lazy(() => import("./routeWrapper"));
import DashboardRoutes from "./dashboardRoutes";
import DefaultPaths from "./path";
import BASEURL from "../../config";
//---------------- End Helper Import --------------------//

(() => {
    // better if we can put some condition here.
    // if() {
    import("../constants/api").then(Api => {
        Api = Api.default;
        if (
            Api._getCookieValue("cid") &&
            Api._getCookieValue("token") &&
            Api._getCookieValue("org_id") &&
            Api._getCookieValue("viewType")
        ) {
            Api._setKeyinBulk({
                cid: Api._getCookieValue("cid"),
                token: Api._getCookieValue("token"),
                org_id: Api._getCookieValue("org_id"),
                viewType: Api._getCookieValue("viewType")
            });
        }
        if(!["https://v2-uat-api.happay.in/", "https://v2-api.happay.in/"].includes(BASEURL)) {
            Api._setCookie('baseUrl', BASEURL);
        } else {
            Api._removeCookie('baseUrl');
        }
    });
    // }
})();

const Routes = () => (
    <Router history={history}>
        <Suspense fallback={<Loader />}>
            <Switch>
                <Redirect exact from="/" to="/login" />
                {/* <Route exact path={"/activate"} component={RblToSbmMigration} /> */}
                <Route exact path={["/login", "/login/:loginTabs/:token?"]} component={LoginTab} />

                <RouteWrapper
                    exact
                    layout={Dashboard}
                    path={DefaultPaths}
                    routes={DashboardRoutes}
                />
                <Route exact path="*">
                    <ErrorPage />
                </Route>
            </Switch>
        </Suspense>
    </Router>
);

export default Routes;
